import React from 'react';
import { useSelector } from 'react-redux';
import SVGIcon from '../SVGIcon'

const AudiencePeopleChart = props => {
  const total = props.audiencePreviewData.total;
  const uniqueNumber = props.audiencePreviewData.audienceUniques;

  const percent = uniqueNumber/ total * 100;

  let chartArray = [0,5,10,15,20,25,30,35,40,45,50,55,60,65,70,75,80,85,90,95];

  return (
    <div className="Audience_people-chart-container">
      {chartArray.map((item,idx) =>{

        return(
          <div className={`Audience_people-chart-container_single-user${percent > item ? `_light` : ``}`}
          key={idx}>
          <SVGIcon icon="user" />
          </div>
        )
      })}

    </div>
  );
};

export default AudiencePeopleChart;
